import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { login } from '../../services/Saga/loginSaga/actions';
import { Colors } from '../../utils/colors';
import './style.scss';
import { Button } from '@mui/material';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';

export const Login = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isVisiblePass, setIsVisiblePass] = useState(false);
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const onPressLogin = () => {
    dispatch(login({ email, password, navigate }));
  };

  useEffect(() => {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }, []);

  return (
    <div className='mainWrapper' style={{ backgroundColor: Colors.mainBlack }}>
      <div className='wrapper'>
        <text
          className='titleLogin'
          style={{
            color: Colors.mainYellow,
          }}
        >
          Omsetningen
        </text>
        <div>
          <div
            style={{
              backgroundColor: Colors.mainBlack,
            }}
            className='inputsContainer'
          >
            <div className='inputEmailContainer'>
              <text
                style={{
                  color: Colors.white,
                }}
                className='inputTitle'
              >
                {t('email')}
              </text>
              <input
                type='email'
                style={{
                  backgroundColor: Colors.mainBlack,
                }}
                placeholder={t('email')}
                className='inputEmail'
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className='inputPasswordContainer'>
              <text
                style={{
                  color: Colors.white,
                }}
                className='inputTitle'
              >
                {t('password')}
              </text>
              <input
                className='inputPassword'
                type={isVisiblePass ? 'text' : 'password'}
                style={{
                  backgroundColor: Colors.mainBlack,
                }}
                placeholder={t('password')}
                onChange={(e) => setPassword(e.target.value)}
              />
              <div
                onClick={() => setIsVisiblePass(!isVisiblePass)}
                className='eyeIconContainerLogin'
              >
                {isVisiblePass ? <EyeInvisibleOutlined /> : <EyeOutlined />}
              </div>
            </div>
            <Button
              style={{
                color: Colors.white,
              }}
              className='buttonLogin'
              onClick={onPressLogin}
            >
              {t('log_in')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
